/**
 * The connection to Gestify, read only (docs/adr/ADR-011): the hosts of its two
 * environments and the contracts of the administrators' check. The data the
 * modules read from Gestify come with their own contracts, module by module.
 */
/** Login, refresh and session go to the auth host; everything else to the data host. */
export const GESTIFY_HOSTS = {
    beta: { auth: 'https://auth-beta-api.gestify.it', data: 'https://beta-api.gestify.it' },
    production: { auth: 'https://auth-api.gestify.it', data: 'https://api.gestify.it' },
};
export function isGestifyEnvironment(value) {
    return value === 'beta' || value === 'production';
}
//# sourceMappingURL=gestify-contracts.js.map